// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/webpack-dev-server/client/index.js?protocol=auto%3A&username=&password=&hostname=0.0.0.0&port=0&pathname=%2Fws&logging=info&overlay=true&reconnect=10&hot=false&live-reload=true");
let __webpack_exports__ = __webpack_require__("./src/index.js");
